import React, { useState, useEffect } from 'react';
import { Panel } from 'primereact/panel';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { travelService } from '../../services/extensions';
import { userTravelDetailsRecords } from '../../services/common/states';
import { useNavigate } from 'react-router';
import { useFormik } from 'formik';
import { setTravelTab } from '../../services/store/userSlice';
import { useDispatch } from 'react-redux';
import TravelDataTable from './travel-datatable';
import moment from 'moment';


const TravelDetails = () => {
    const dispatch = useDispatch();
    const [buTypes, setBuTypes] = useState([]);
    const [countryName, setCountryName] = useState([]);
    const [stateName, setStateOptions] = useState([]);
    const [daCurrency, setDaCurrency] = useState([]);
    const [allocations, setAllocations] = useState([]);
    const [selectedProject, setSelectedProject] = useState(null);
    const [customerOptions, setCustomerOptions] = useState([]);
    const navigate = useNavigate();
    var currentUser = JSON.parse(localStorage.getItem("user"));
    useEffect(() => {
        GetAllBusinessUnit();
        GetAllCountry();
        GetAllDACurrency();
        GetAllocationByUser();
        GetAllCustomer();
        userTravelDetailsRecords.subscribe((result) => {
            if (result) {
                searchForm.setValues({
                    clientName: result.clientName,
                    projectId: result.projectId,
                    projectManager: currentUser.superior?.firstName ? (currentUser.superior?.firstName || "") + " " + (currentUser.superior?.lastName || "") : result.projectManager,
                    buFunctionalHead: result.buFunctionalHead,
                    countryOfVisit: result.countryOfVisit,
                    stateCities: result.stateCities,
                    journeyDate: moment(result.journeyDate).toDate(),
                    returnDate: null,
                    costCentre: result.costCentre,
                    daCurrency: result.daCurrency,
                    daEntitleAmount: result.daEntitleAmount,
                    seatRequest: result.seatRequest,
                    mealRequest: result.mealRequest,
                    frequentFlyerNumber: result.frequentFlyerNumber,
                    // selectedCountryName: result.selectedCountryName
                });
            } else {
                searchForm.setValues({
                    returnDate: null,
                });
            }
        });
    }, []);

    const searchForm = useFormik({
        initialValues: {
            clientName: '',
            projectId: '',
            projectManager: (currentUser.superior?.firstName || "") + " " + (currentUser.superior?.lastName || ""),
            buFunctionalHead: '',
            countryOfVisit: '',
            stateCities: '',
            journeyDate: null,
            returnDate: null,
            costCentre: '',
            daCurrency: '',
            daEntitleAmount: '',
            seatRequest: '',
            mealRequest: '',
            frequentFlyerNumber: '',
            // selectedCountryName: null
        },
        validate: (data) => {
            console.log(data, "Validation")
            let errors = {};
            if (!data.clientName) {
                errors.clientName = 'Enter Client Name';
            }
            if (!data.projectId) {
                errors.projectId = 'Enter Project ID';
            }
            if (!data.projectManager) {
                errors.projectManager = 'Enter User Project Manager';
            }

            if (!data.buFunctionalHead) {
                errors.buFunctionalHead = 'Enter BU Functional Head';
            }
            if (!data.countryOfVisit) {
                errors.countryOfVisit = 'Select Country Name';
            }
            if (!data.stateCities) {
                errors.stateCities = 'Enter City Name';
            }
            if (!data.journeyDate) {
                errors.journeyDate = 'Enter Journey Date';
            }
            if (!data.returnDate) {
                errors.returnDate = 'Enter Return Date';
            }

            if (!data.daCurrency) {
                errors.daCurrency = 'Enter DA Currency';
            }
            if (!data.daEntitleAmount) {
                errors.daEntitleAmount = 'Enter DA Intitle Amount';
            }
            if (!data.seatRequest) {
                errors.seatRequest = 'Enter No of Seats';
            }
            if (!data.mealRequest) {
                errors.mealRequest = 'Enter No of Meal';
            }
            return errors;
        },
        onSubmit: (data) => {
            console.log('Form data:', data);
            saveUserTravelRecords(data);
        },
    });

    const isFormFieldValid = (name) =>
        !!(searchForm.touched[name] && searchForm.errors[name]);
    const getFormErrorMessage = (name) => {
        return (
            isFormFieldValid(name) && (
                <small className="p-error">{searchForm.errors[name]}</small>
            )
        );
    };

    const saveUserTravelRecords = (data) => {
        const formattedData = {
            ...data,
            journeyDate: moment(data.journeyDate).format('YYYY-MM-DD'),
            returnDate: moment(data.returnDate).format('YYYY-MM-DD')
        };
        console.log(formattedData, "saveUserTravelRecords");
        console.log('Formatted data:', formattedData);  
        dispatch(setTravelTab(2));
        userTravelDetailsRecords.next(formattedData);
        // navigate('/PassportDetails');
    }

    const GetAllBusinessUnit = () => {
        travelService.GetAllBusinessUnit()
            .then(response => {
                if (response.data.success) {
                    const options = response.data.data.map(bu => ({
                        label: bu.title,
                        value: bu.id
                    }));
                    setBuTypes(options);
                }
            })
            .catch(error => {
                console.error('Error fetching business units:', error);
            });
    };

    const GetAllCountry = () => {
        travelService.GetAllCountry()
            .then(response => {
                if (response.data.success) {
                    const options = response.data.data.map(country => ({
                        label: country.countryName,
                        value: country.id
                    }));
                    console.log(options, "optionsoptionsoptions")
                    setCountryName(options);
                }
            })
            .catch(error => {
                console.error('Error fetching countries:', error);
            });
    };

    const getStateByCountryId = (countryId) => {
        travelService.getStateByCountryId(countryId)
            .then(response => {
                if (response.data.success) {
                    const states = response.data.states;
                    const options = states.map(state => ({
                        label: state.stateName,
                        value: state.id
                    }));
                    setStateOptions(options);
                }
            })
            .catch(error => {
                console.error('Error fetching states:', error);
            });
    };

    const GetAllDACurrency = () => {
        travelService.GetAllDACurrency()
            .then(response => {
                if (response.data.success) {
                    const options = response.data.data.map(daCurrency => ({
                        label: `${daCurrency.title} (${daCurrency.symbol})`,
                        value: daCurrency.code
                    }));
                    setDaCurrency(options);
                }
            })
            .catch(error => {
                console.error('Error fetching DA currency:', error);
            });
    };

    const GetAllocationByUser = () => {
        travelService.GetAllocationByUser(/* pass userId here */)
            .then(response => {
                if (response.data.success) {
                    setAllocations(response.data.data);
                    if (response.data.data.length === 1) {
                        setSelectedProject(response.data.data[0].Project);
                        searchForm.setFieldValue('projectId', response.data.data[0].Project.id); // Set projectId
                    }
                }
            })
            .catch(error => {
                console.error('Error fetching allocations:', error);
            });
    };
    const GetAllCustomer = () => {
        travelService.GetAllCustomer()
            .then(response => {
                if (response.data.success) {
                    const options = response.data.data.map(customer => ({
                        label: customer.title,
                        value: customer.id
                    }));
                    setCustomerOptions(options);
                }
            })
            .catch(error => {
                console.error('Error fetching customers:', error);
            });
    };

    return (
        <div className="tabview-demo">
            <form onSubmit={searchForm.handleSubmit} autoComplete='off'>
                <Panel>
                    <div className="formgrid grid">
                        <div className="field col-4 single-category">
                            <label htmlFor="clientName" className="font-bold block mb-2">Client Name</label>
                            <Dropdown
                                id="clientName"
                                name="clientName"
                                value={searchForm.values.clientName}
                                options={customerOptions}
                                onChange={(e) => searchForm.setFieldValue('clientName', e.value)}
                                placeholder="Select a client"
                                className="w-100"
                            />
                            {getFormErrorMessage("clientName")}
                        </div>
                        <div className="field col-4">
                            <label htmlFor="projectId" className="font-bold block mb-2">Project Name</label>
                            {allocations.length > 1 ? (
                                <Dropdown
                                    id="projectId"
                                    name="projectId"
                                    value={searchForm.values.projectId}
                                    options={allocations.map(a => ({ label: a.Project.title, value: a.Project.id }))}
                                    onChange={(e) => {
                                        const selected = allocations.find(a => a.Project.id === e.value);
                                        if (selected) {
                                            setSelectedProject(selected.Project);
                                            searchForm.setFieldValue('projectId', selected.Project.id);
                                        }
                                    }}
                                    placeholder="Select Project"
                                    className="w-100"
                                />
                            ) : (
                                <InputText
                                    id="projectId"
                                    name="projectId"
                                    placeholder="Project Name"
                                    value={allocations[0]?.Project?.title || ''}
                                    disabled={true}
                                    className="w-100"
                                />
                            )}
                            {getFormErrorMessage("projectId")}
                        </div>
                        <div className="field col-4">
                            <label htmlFor="projectManager" className="font-bold block mb-2">Project Manager</label>
                            <InputText
                                id="projectManager"
                                name="projectManager"
                                placeholder="Project Manager"
                                value={searchForm.values.projectManager}
                                onChange={searchForm.handleChange}
                                className="w-100"
                            />
                            {getFormErrorMessage("projectManager")}
                        </div>
                        <div className="field col-4 single-category">
                            <label htmlFor="buFunctionalHead" className="font-bold block mb-2">BU/Functional Head</label>
                            <Dropdown
                                id="buFunctionalHead"
                                name="buFunctionalHead"
                                value={searchForm.values.buFunctionalHead}
                                options={buTypes}
                                onChange={(e) => searchForm.setFieldValue('buFunctionalHead', e.value)}
                                placeholder="BU/Functional Head"
                                className="w-100"
                            />
                            {getFormErrorMessage("buFunctionalHead")}
                        </div>
                        <div className="field col-4 single-category">
                            <label htmlFor="countryOfVisit" className="font-bold block mb-2">Country of visit</label>
                            <Dropdown
                                id="countryOfVisit"
                                name="countryOfVisit"
                                value={searchForm.values.countryOfVisit}
                                options={countryName}
                                onChange={(e) => {
                                    searchForm.setFieldValue('countryOfVisit', e.value);
                                    getStateByCountryId(e.value);
                                }}
                                placeholder="Country of visit"
                                className="w-100"
                            />
                            {getFormErrorMessage("countryOfVisit")}
                        </div>
                        <div className="field col-4 single-category">
                            <label htmlFor="stateCities" className="font-bold block mb-2">State/Cities</label>
                            <Dropdown
                                id="stateCities"
                                name="stateCities"
                                value={searchForm.values.stateCities}
                                options={stateName}
                                onChange={(e) => searchForm.setFieldValue('stateCities', e.value)}
                                placeholder="State/Cities"
                                className="w-100"
                            />
                            {getFormErrorMessage("stateCities")}
                        </div>
                        <div className="field col-4">
                            <label htmlFor="journeyDate" className="font-bold block mb-2">Journey Date</label>
                            <Calendar
                                id="journeyDate"
                                name="journeyDate"
                                value={searchForm.values.journeyDate}
                                onChange={(e) => searchForm.setFieldValue('journeyDate', e.value)}
                                readOnlyInput
                                dateFormat="dd/mm/yy"
                                mask="99/99/9999"
                                placeholder="Journey Date"
                                className="w-100"
                            />
                            {getFormErrorMessage("journeyDate")}
                        </div>
                        <div className="field col-4">
                            <label htmlFor="returnDate" className="font-bold block mb-2">Return Date</label>
                            <Calendar
                                id="returnDate"
                                name="returnDate"
                                value={searchForm.values.returnDate}
                                onChange={(e) => searchForm.setFieldValue('returnDate', e.value)}
                                readOnlyInput
                                dateFormat="dd/mm/yy"
                                mask="99/99/9999"
                                placeholder="Return Date"
                                className="w-100"
                            />
                            {getFormErrorMessage("returnDate")}
                        </div>
                        <div className="field col-4">
                            <label htmlFor="costCentre" className="font-bold block mb-2">Cost Centre</label>
                            <InputText
                                id="costCentre"
                                name="costCentre"
                                placeholder="Cost Centre"
                                value={searchForm.values.costCentre}
                                onChange={searchForm.handleChange}
                                className="w-100"
                            />
                            {getFormErrorMessage("costCentre")}
                        </div>
                        {/* <div className="field col-4 single-category">
                            <label htmlFor="daCurrency" className="font-bold block mb-2">DA Currency</label>
                            <Dropdown
                                id="daCurrency"
                                name="daCurrency"
                                value={searchForm.values.daCurrency}
                                options={daCurrency}
                                onChange={(e) => searchForm.setFieldValue('daCurrency', e.value)}
                                placeholder="DA Currency"
                                className="w-100"
                            />
                            {getFormErrorMessage("daCurrency")}
                        </div> */}

                        <div className="field col-4 single-category">
                            <label htmlFor="daCurrency" className="font-bold block mb-2">DA Currency</label>
                            <Dropdown
                                // id="daCurrency"
                                name="daCurrency"
                                value={searchForm.values.daCurrency}
                                options={daCurrency}
                                onChange={(e) => searchForm.setFieldValue('daCurrency', e.value)}
                                placeholder="DA Currency"
                                className="w-100"
                            />
                            {getFormErrorMessage("daCurrency")}
                        </div>


                        <div className="field col-4 single-category">
                            <label htmlFor="daEntitleAmount" className="font-bold block mb-2">DA Entitle Amount</label>
                            <InputText
                                id="daEntitleAmount"
                                name="daEntitleAmount"
                                placeholder="DA Entitle Amount"
                                value={searchForm.values.daEntitleAmount}
                                onChange={searchForm.handleChange}
                                className="w-100"
                            />
                            {getFormErrorMessage("daEntitleAmount")}
                        </div>
                        <div className="field col-4 single-category">
                            <label htmlFor="seatRequest" className="font-bold block mb-2">Seat Request</label>
                            <Dropdown
                                id="seatRequest"
                                name="seatRequest"
                                value={searchForm.values.seatRequest}
                                options={[
                                    { label: 'Window', value: 'Window' },
                                    { label: 'Aisle', value: 'Aisle' }
                                ]}
                                onChange={(e) => searchForm.setFieldValue('seatRequest', e.value)}
                                placeholder="Select Seat Request"
                                className="w-100"
                            />
                            {getFormErrorMessage("seatRequest")}
                        </div>

                        <div className="field col-4 single-category">
                            <label htmlFor="mealRequest" className="font-bold block mb-2">Meal Request</label>
                            <Dropdown
                                id="mealRequest"
                                name="mealRequest"
                                value={searchForm.values.mealRequest}
                                options={[
                                    { label: 'AVML (Asian Vegetarian Meal)', value: 'AVML' },
                                    { label: 'HNML (Hindu Meal)', value: 'HNML' },
                                    { label: 'MOML (Muslim Meal)', value: 'MOML' }
                                ]}
                                onChange={(e) => searchForm.setFieldValue('mealRequest', e.value)}
                                placeholder="Select Meal Request"
                                className="w-100"
                            />
                            {getFormErrorMessage("mealRequest")}
                        </div>

                        <div className="field col-4 single-category">
                            <label htmlFor="frequentFlyerNumber" className="font-bold block mb-2">Frequent Flyer Number</label>
                            <InputText
                                id="frequentFlyerNumber"
                                name="frequentFlyerNumber"
                                placeholder="Frequent Flyer Number"
                                value={searchForm.values.frequentFlyerNumber}
                                onChange={searchForm.handleChange}
                                className="w-100"
                            />
                            {getFormErrorMessage("frequentFlyerNumber")}
                        </div>
                    </div>
                </Panel>

                <Panel>
                    <div className="formgrid grid">
                        {/* <div className="field col-4 card flex flex-wrap gap-3">
                            <Button label="Save as draft" icon="pi pi-inbox" aria-label="Save" severity="primary" type='submit' />
                        </div> */}
                        <div className="field col-4 card flex flex-wrap gap-3">
                            <Button label="Save & Next" aria-label="Save" severity="success" type='submit' icon="pi pi-save" />
                        </div>
                    </div>
                </Panel>
            </form>

            <Panel>
                <TravelDataTable />
            </Panel>
        </div>
    );
}

export default TravelDetails;
